import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./locales/fr";
import en from "./locales/en";
import es from "./locales/es";

export const LANGUAGES = [
  { code: "fr", label: "FR", locale: "fr-CA", htmlLang: "fr-CA" },
  { code: "en", label: "EN", locale: "en-CA", htmlLang: "en-CA" },
  { code: "es", label: "ES", locale: "es-ES", htmlLang: "es" },
];

export const localeOf = (code) =>
  (LANGUAGES.find((l) => l.code === code) || LANGUAGES[0]).locale;

export const htmlLangOf = (code) =>
  (LANGUAGES.find((l) => l.code === code) || LANGUAGES[0]).htmlLang;

const stored = localStorage.getItem("vy_lang");
const fromQuery = new URLSearchParams(window.location.search).get("lang");
const initial = LANGUAGES.some((l) => l.code === fromQuery)
  ? fromQuery
  : LANGUAGES.some((l) => l.code === stored) ? stored : "fr";

i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr }, en: { translation: en }, es: { translation: es } },
  lng: initial,
  fallbackLng: "fr",
  supportedLngs: LANGUAGES.map((l) => l.code),
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = htmlLangOf(lng);
});
document.documentElement.lang = htmlLangOf(initial);

export default i18n;
